import { BaseGlassMixin } from "../../common/components/GlassMixin"
import BackgroundImage from "../../static/images/smartsetter-glass-effect-light-v4-bg.png"

export const USER_AUTH_FONT_FAMILY = "Inter, sans-serif"

export const userAuthPageSx = {
  fontFamily: USER_AUTH_FONT_FAMILY,
  color: "text.primary",
}

export const userAuthLayoutBackgroundSx = {
  minHeight: "100vh",
  width: "100%",
  backgroundImage: `url(${BackgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
}

export const userAuthCardSx = {
  position: "relative",
  borderRadius: "16px",
  ...BaseGlassMixin,
  border: "1px solid rgba(255, 255, 255, 0.65)",
  boxShadow: "0 8px 32px rgba(17, 12, 46, 0.08)",
}

export const authFieldSx = {
  "& .MuiInputLabel-root": {
    zIndex: 2,
    color: "text.secondary",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "primary.main",
  },
  "& .MuiInputLabel-shrink": {
    zIndex: 3,
    backgroundColor: "rgba(255, 255, 255, 0.98)",
    px: 0.75,
    py: 0.125,
    borderRadius: "6px",
    border: "1px solid rgba(255, 255, 255, 0.95)",
    lineHeight: 1.2,
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "rgba(255, 255, 255, 0.72)",
  },
}
